import React, { useCallback } from "react";
import { REWRITE_OUTPUT_CARDS } from "../../../../../src/shared/constants";
import WriteSettings from "src/components/WriteSettings";
import { useStoryBibleStore } from "src/stores/storyBibleStore";
import { useSudowriteStore } from "src/stores/sudowriteStore";
import MenuSelect from "src/sudokit/components/SudoSelect/MenuSelect";

const NOOP = () => {};

export function WritingSettingsSection() {
  const editorOptions = useSudowriteStore((state: any) => state.editorOptions);
  const setEditorOptions = useSudowriteStore(
    (state: any) => state.setEditorOptions,
  );
  const metadata = useStoryBibleStore((state: any) => state.metadata);
  const setMetadata = useStoryBibleStore((state: any) => state.setMetadata);

  const updateEditorOptions = useCallback(
    (patch: Record<string, unknown>) => {
      const currentState = useSudowriteStore.getState() as any;
      currentState.setEditorOptions({
        ...(currentState.editorOptions || {}),
        ...patch,
      });
    },
    [],
  );

  const rewriteOptions = REWRITE_OUTPUT_CARDS.map((option) => ({
    ...option,
    value: String(option.value),
  }));
  const rewriteOutputCards = String(
    editorOptions?.rewriteOutputCards ??
      REWRITE_OUTPUT_CARDS[0]?.value ??
      "",
  );
  return (
    <section
      className="flex flex-col text-left text-[var(--grey-0)]"
      data-section="writing"
    >
      <h2 className="m-0 mb-5 font-inter text-xl font-medium text-[var(--grey-0)]">
        Write
      </h2>

      <WriteSettings
        surface="section"
        includeKeyDetails={false}
        initialWormholeOutputLength={editorOptions?.wormholeOutputLength}
        initialWormholeOutputCards={editorOptions?.wormholeOutputCards}
        initialCreativitySliderPosition={
          editorOptions?.creativitySliderPosition
        }
        initialWriteModel={editorOptions?.writeModel}
        editorOptions={editorOptions}
        setEditorOptions={setEditorOptions}
        setSettingsOpen={NOOP}
        setModalOpen={NOOP}
        metadata={metadata}
        setMetadata={setMetadata}
      />

      <div
        className="my-6 h-px w-full bg-[var(--grey-3)]"
        aria-hidden="true"
      />

      <h2 className="m-0 mb-5 font-inter text-xl font-medium text-[var(--grey-0)]">
        Rewrite
      </h2>
      <div
        className="flex flex-col items-start gap-2.5"
        role="group"
        aria-label="Rewrite card count control"
      >
        <span className="font-inter text-base font-medium text-[var(--grey-0)]">
          Number of cards
        </span>
        <div className="w-[60px] [&_button]:w-full">
          <MenuSelect
            options={rewriteOptions}
            value={rewriteOutputCards}
            label="Rewrite number of cards"
            variant="secondary"
            onChange={(value: string) => {
              updateEditorOptions({ rewriteOutputCards: Number(value) });
            }}
            optionAlignment="left"
            menuAlign="start"
          />
        </div>
      </div>
    </section>
  );
}

export default WritingSettingsSection;
